import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { StoreConnectionClient, StoresClient, API_BASE_URL } from './app/service/backoffice';
import { CartClient, CategoryClient, ItemClient, LanguageClient, OrderClient, API_BASE_URL as FRONTEND_API_BASE_URL } from './app/service/deliordering-frontend';
import { environment } from './environments/environment';
import { APP_INITIALIZER, isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { Directionality } from '@angular/cdk/bidi';
import { provideMissingTranslationHandler, provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { getSavedApiLanguage } from './app/i18n/languages';
import { UiTranslationLoader } from './app/i18n/ui-translation-loader';
import { SourceKeyFallback } from './app/i18n/source-key-fallback';
import { LanguageService, UiDirectionality } from './app/service/language.service';
import { devApiProxyInterceptor } from './app/service/dev-api-proxy.interceptor';
import { AppUpdateService } from './app/service/app-update.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([devApiProxyInterceptor])),
    provideTranslateService({
      fallbackLang: 'en',
      lang: getSavedApiLanguage(),
      loader: provideTranslateLoader(UiTranslationLoader),
      missingTranslationHandler: provideMissingTranslationHandler(SourceKeyFallback)
    }),
    { provide: APP_INITIALIZER, multi: true, deps: [LanguageService], useFactory: (language: LanguageService) => () => language.initialize() },
    { provide: Directionality, useClass: UiDirectionality },
    // 自动检查更新：部署新版本后，Service Worker 在后台下载，回到首页空闲时自动刷新
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: APP_INITIALIZER, multi: true, deps: [AppUpdateService], useFactory: (updates: AppUpdateService) => () => updates.start() },
    // API客户端配置
    // 点餐接口（Deliordering-Frontend 文档生成：deliordering-frontend.ts）
    CartClient,
    CategoryClient,
    ItemClient,
    LanguageClient,
    OrderClient,
    { provide: FRONTEND_API_BASE_URL, useValue: environment.apiRoot },
    // 门店设置等（V1 文档生成：backoffice.ts）；界面语言包见 i18n-pack.client.ts
    StoreConnectionClient,
    StoresClient,
    { provide: API_BASE_URL, useValue: environment.apiRoot }
  ]
}).catch(err => console.error(err));
